// extracted by mini-css-extract-plugin
module.exports = {"tabNav":"AccountSettingsTabs_tabNav__1UUEk","active":"AccountSettingsTabs_active__3AGG5"};